import React from 'react'
import DocTableHeader from './components/DocTableHeader'
import DocTableData from './components/DocTableData'
import searchViewMap from './Index';
import './components/docTableStyle.scss'

const DocTableContainer = (props)=>{
    const {viewData, onSearchRequest, reloadSearch, rowSelector, stickyTop = 30} = props;

    return(
      <div className="uiSecContents uiChildGrid uiStickyTable"
        style={{ '--sticky-top': `${stickyTop}px` }}
      >
        <table cellSpacing="0" width="100%">
          <thead className="uiTableHeading saras-tour-search-results-header">
            <DocTableHeader viewData={viewData.headerRows.headerRow} onSearchRequest={onSearchRequest}
               rowSelector={rowSelector} viewMap={searchViewMap}></DocTableHeader>
          </thead>
          <tbody className="uiTableBody">
            <DocTableData viewData={viewData} viewMap={searchViewMap} rowSelector={rowSelector} reloadSearch={reloadSearch}></DocTableData>
          </tbody>  
        </table>
      </div>
    )
}

export default DocTableContainer
